// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1CYRhh","container":"_3_e3kz","content":"sXycWa","buttonsContainer":"_2d-V9v"};